import QuickSearch from './src/quicksearch.vue';

QuickSearch.install = function (Vue) {
    Vue.component(QuickSearch.name, QuickSearch);
};

export default QuickSearch;